import axios, { ResponseType } from './axios';

export const getHandbookBySolution = (): ResponseType => {
  return axios.get('/handbooks');
};
